// extracted by mini-css-extract-plugin
module.exports = {"reviewerInfo":"FiveStarReviewsBlock_reviewerInfo__3Erhx","tutorInfo":"FiveStarReviewsBlock_tutorInfo__3JO99"};